import { render } from "./OzonOauth.vue?vue&type=template&id=254f4560&scoped=true"
import script from "./OzonOauth.vue?vue&type=script&lang=js"
export * from "./OzonOauth.vue?vue&type=script&lang=js"

import "./OzonOauth.vue?vue&type=style&index=0&id=254f4560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254f4560"]])

export default __exports__